import gql from 'graphql-tag';
import { fieldsToGqlString, mergeByIdNewAtTop } from '../../../util/shared/vue-global';
import { clients } from '../../../util/clients';

const { backend } = clients.direct;
const defaultSaiMonthlySummaryFields = {
  _id: '',
  fiscalYear: '',
  dateSentToSAI: '',
  month: '',
  year: '',
  message: '',
  comment: '',
  isLocked: false,
  lockDate: '',
  isUnUsable: '',
  summaryDetailsGLBanks: '',
  summaryDetailsGLFunds: '',
  bankTotalFromGL: '',
  fundTotalFromGL: '',
  odTotalMonthlySummary: '',
  glBankMonthlySummary: '',
  glFundMonthlySummary: '',
};

export const saiMonthlySummaryTransaction = {
  namespaced: true,
  state: () => ({
    regYears: {},
    isLocked: '',
  }),
  mutations: {
    setFiscalRegYears(state, regYears) {
      state.regYears = regYears;
    },
    setSumaryLockUnlock(state, isLocked) {
      state.isLocked = isLocked;
    },
  },
  actions: {
    async loadSaiMonthlySummary({ commit, dispatch }, {
      criteria, fields, baseCrudKey,
    }) {
      let results;
      const gqlfields = fields || defaultSaiMonthlySummaryFields;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query saiMonthlySummary($criteria: saiMonthlySummaryCriteriaType) {
            saiMonthlySummary(criteria: $criteria) {
                ${fieldsToGqlString(gqlfields)},
              }
            }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        const saiMonthlySummaryTrans = results.data ? results.data.saiMonthlySummary
            || [] : [];
        commit('base/crud/setItems', [baseCrudKey, saiMonthlySummaryTrans], { root: true });
        return saiMonthlySummaryTrans;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was problem loading the Transaction List!', { root: true });
      }
      return [];
    },
    async upsertSaiMonthlySummary({ dispatch, rootGetters, commit }, {
      item, fields, baseCrudKey,
    }) {
      let results;
      try {
        const gqlfields = fields || defaultSaiMonthlySummaryFields;
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertSaiMonthlySummary ($item: saiMonthlySummaryInputType!)  {
                upsertSaiMonthlySummary(upsert: $item) {
                    ${fieldsToGqlString(gqlfields)},
                  }
                }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const saiMonthlySummaryTransStateData = rootGetters['base/crud/items'](baseCrudKey);
        const newTransaction = results.data ? (results.data.upsertSaiMonthlySummary
            || {}) : {};
        const newList = mergeByIdNewAtTop(saiMonthlySummaryTransStateData || [], newTransaction);
        commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
        return newTransaction;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the transaction!', { root: true });
      }
      return {};
    },
    async deleteSaiMonthlySummary({ commit, rootGetters, dispatch }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation deleteSaiMonthlySummary ($id: ID!)  {
            deleteSaiMonthlySummary(id: $id) {
                  _id
                }
              }`,
          variables: {
            id: item._id,
          },
        });
        clients.handleGQLErrors(results, commit);
        const delId = results.data ? (results.data.deleteSaiMonthlySummary || {})._id : null;
        const saiMonthlySummaryTransData = rootGetters['base/crud/items'](baseCrudKey);
        const updatedData = saiMonthlySummaryTransData.filter((d) => d._id !== delId);
        commit('base/crud/setItems', [baseCrudKey, updatedData], { root: true });
        return delId;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while deleting the transaction!', { root: true });
      }
      return null;
    },
    async loadFiscalRegYears({ commit, dispatch }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`{
            saiMonthlySummaryStatsFYRange { max, min },
          }`,
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        const range = results.data ? (results.data.saiMonthlySummaryStatsFYRange || {}) : null;
        commit('setFiscalRegYears', results.data.saiMonthlySummaryStatsFYRange);
        return range;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting min/max Fiscal Year ranges.', { root: true });
      }
      return null;
    },
    async saiMonthlyCollectInformation({ commit, dispatch }, { criteria }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query
          saiMonthlyCollectInformation ($criteria: saiMonthlySummaryCriteriaType) {
            saiMonthlyCollectInformation(criteria: $criteria) {
              status
            },
          }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        const result = results.data ? (results.data.saiMonthlyCollectInformation || {}) : {};
        return result;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There is a problem while collecting GL information.', { root: true });
      }
      return null;
    },
  },
};
export default saiMonthlySummaryTransaction;
